import { NgModule, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { RequestComponent } from './recruitment/request/request.component';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule, ModalModule, PaginationModule, BsDatepickerConfig } from 'ngx-bootstrap';
import { ModalEmploymentHistoryComponet } from '../modales/recruitment/employment-history/modal-employment-history.component';
import { ModalLanguageComponet } from '../modales/recruitment/language/modal-language.component';
import { ModalStudyComponet } from '../modales/recruitment/study/modal-study.component';
import { RecruitmentService } from './recruitment/recruitment.service';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';
import { MatStepperModule } from '@angular/material/stepper';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { ModalReferenceComponet } from '../modales/recruitment/reference/modal-reference.component';
import { ModalAppearanceComponet } from '../modales/recruitment/appearance/modal-appearance.component';
import { NgxMaskModule } from 'ngx-mask'
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { RequestReviewComponent } from './recruitment/request-review/request-review.component';
import { UpperCaseDirective, RemoveTildeDirective, LowerCaseDirective } from 'app/shared/directives/uppercase.directive';
import { OnlyNumberDirective } from 'app/shared/directives/only-number.directive';
import { NgSlimScrollModule, SLIMSCROLL_DEFAULTS } from 'ngx-slimscroll';
import { RequisitionReviewComponent } from './opening/requisition-review/requisition-review.component';
import { RequisitionDetailComponent } from './opening/requisition-detail/requisition-detail.component';
import { OpeningService } from './opening/opening.service';
import { RequisitionTrackingComponent } from './opening/requisition-detail/requisition-tracking/requisition-tracking.component';
import { UserComponent } from './security/user/user.component';
import { SystemComponent } from './security/system/system.component';
import { RoleComponent } from './security/Role/role.component';
import { IdentityService } from './security/identity.service';
import { ModalUserComponet } from '../modales/security/user/modal-user.component';
import { ModalUserRoleComponet } from '../modales/security/user-role/modal-user-role.component';
import { ModalSystemModuleComponet } from '../modales/security/system-module/modal-system-module.component';
import { ChangePasswordComponent } from './security/change-password/change-password.component';
import { ProfileComponent } from './recruitment/profile/profile.component';
import { ModalEmploymentHistoryCommentsComponent } from '../modales/recruitment/employment-history/modal-employment-history-comments.component';
export function getDatepickerConfig(): BsDatepickerConfig {
  return Object.assign(new BsDatepickerConfig(), {
    dateInputFormat: 'DD/MM/YYYY'
  });
}
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { PopoverModule } from 'ngx-bootstrap/popover';
registerLocaleData(localeEs);
import { HolidayApprovalComponent } from './request/holiday/holiday-approval.component';
import { HolidayRequestComponent } from './request/holiday/holiday-request.component';
import { EmployeeComponent } from './request/employee/employee.component';
import { ModalReasonRejectionComponent } from '../modales/request/holiday/modal-reason-rejection.component';
import { HolidayService } from './request/holiday.service';
import { ModalReasonCancelComponent } from '../modales/request/holiday/modal-reason-cancel.component';
import { InabilityRequestComponent } from './request/inability/inability-request.component';
import { InabilityRecordsComponent } from './request/inability/inability-records.component';
import { AngularMyDatePickerModule } from 'angular-mydatepicker';
import { InabilityService } from './request/inability.service';
import { ExcelService } from './request/excel.service';
import { ModalEmployeesComponet } from '../modales/employees/modal-employees.component';
import { WorkLeaveComponent } from './request/work-leave/work-leave.component';
import { WorkLeaveService } from './request/workLeave.service';
import { WorkLeaveRecordsComponent } from './request/work-leave/work-leave-records.component';
import { RequisitionEditComponent } from './opening/requisition-detail/requisition-edit/requisition-edit.component';
import { ModalHireEmployeeComponet } from '../modales/recruitment/hire/modal-hire-employee.component';
import { CompaniesComponent } from './organization/companies/companies.component';
import { OrganizationService } from './organization/organization.service';
import { ModalCompanyComponet } from '../modales/organization/company/modal-company.component';
import { CustomersComponent } from './quote/customers/customers.component';
import { ModalCustomerComponet } from '../modales/customer/modal-customer.component';
import { ProjectsComponent } from './quote/projects/projects.component';
import { ModalProjectComponet } from '../modales/customer/project/modal-project.component';
import { ModalPlanComponet } from '../modales/customer/plan/modal-plan.component';
import { CustomerService } from './quote/customer.service';
import { PositionService } from './quote/position.service';
import { ProductsComponent } from './quote/products/products.component';
import { ModalProductComponet } from '../modales/position/product/modal-product.component';
import { ListPositionsComponent } from './quote/positions/list-positions.component';
import { PositionComponent } from './quote/positions/position.component';
import { from } from 'rxjs';
import { ModalCommissionComponet } from '../modales/position/commission/modal-commission.component';
import { ModalVoucherComponet } from '../modales/position/voucher/modal-voucher.component';
import { ListBudgetsComponent } from './quote/budgets/list-budgets.component';
import { BudgetComponent } from './quote/budgets/budget.component';
import { CustomerComponent } from './common/customer/customer.component';
import { BudgetService } from './quote/budget.service';
import { WorkingDayService } from './quote/working-day.service';
import { WorkingDaysComponent } from './quote/working-days/working-days.component';
import { ModalWorkingDayComponet } from '../modales/position/working-day/modal-working-day.component';
import { ModalReasonComponent } from '../modales/common/modal-reason.component';
import { NotesComponent } from './quote/notes/notes.component';
import { ModalNotesComponet } from '../modales/budget/notes/modal-notes.component';
import { RelocationComponent } from './request/relocation/relocation.component';
import { RelocationService } from './request/relocation.service';
import { RelocationRecordsComponent } from './request/relocation/relocation-records.component';
import { ModalBudgetApproverComponent } from '../modales/customer/budget-approver/modal-budget-approver.component';
import { BudgetApprovalComponent } from './quote/budgets/approval/budget-approval.component';
import { ModalDuplicateBudgetComponet } from '../modales/budget/duplicate/modal-duplicate.component';
import { ModalBudgetVersionsComponet } from '../modales/budget/versions/modal-versions.component';
import { AccountActivationComponent } from './security/account-activation/account-activation.component';
import { AdministrationService } from './quote/administration.service';
import { BudgetApprovalSummaryComponent } from './quote/budgets/approval/budget-approval-summary.component';
import { ModalRiskPremiumComponet } from '../modales/organization/risk-premium/modal-risk-premium.component';
import { ModalEmployerRegisterComponet } from '../modales/organization/employer-register/modal-employer-register.component';
import { CurpValidateValidator } from 'app/shared/directives/curp-validate.directive';
import { PayrollService } from './payroll.service';
import { FiveDigitDecimaNumberDirective, TwoDigitDecimaNumberDirective } from 'app/shared/directives/digit-decima-number.directive';
import { ListEmployeesComponent } from './employees/list-employees.component';
import { EmployeeService } from './employee.service';
import { EmployeeUpdateComponent } from './employees/employee-update.component';
import { EmployeeDocumentsComponent } from './employees/employee-documents/employee-documents.component';
import { ModalMassiveUpdateComponet } from '../modales/position/massive-update/modal-massive-update.component';
import { ModalSalaryFormatComponet } from '../modales/employees/salary-format/modal-salary-format.component';
import { EmailService } from './email.service';
import { CustomerCommissionsComponent } from './quote/customer-commissions/customer-commissions.component';
import { ModalCustomerCommissionComponent } from '../modales/position/customer-commission/modal-customer-commission.component';
import { registerAllModules } from 'handsontable/registry';
import { ListCommissionsComponent } from './payroll/commissions/list-commissions.component';
import { CommissionService } from './commission.service';
import { HotTableModule } from '@handsontable/angular';
import { CommissionDetailComponent } from './payroll/commissions/commission-detail.component';
import { RetroactivesComponent } from './payroll/retroactives/retroactives.component';
import { RetroactiveService } from './retroactive.service';
import { ModalEmployerRegisterOfficeComponet } from '../modales/organization/employer-register-office/modal-employer-register-office.component';
import { ListPayrollsComponent } from './payroll/payrolls/list-payrolls.component';
import { PayrollDetailComponent } from './payroll/payrolls/payroll-detail.component';
import { ModalRetentionsComponet } from '../modales/payroll/retentions/modal-retentions.component';
import { ExternalCustomerCommissionComponent } from './payroll/commissions/external/external-customer-commission.component';
import { ExternalCustomerPayrollComponent } from './payroll/payrolls/external/external-customer-payroll.component';
import { ExternalRecruitmentComponent } from './recruitment/external/external-recruitment.component';
import { ModalRequisitionTrackingComponet } from '../modales/opening/requisition-tracking/modal-requisition-tracking.component';
import { EnterAddressComponent } from './recruitment/external/enter-address/enter-address.component';
import { LiquidationComponent } from './request/legal/liquidation/liquidation.component';
import { LiquidationService } from './liquidation.service';
import { DiscountService } from './discount.service';
import { ListLiquidationsComponent } from './request/legal/liquidation/list-liquidations.component';
import { ApproveConciliationOwnComponent } from './request/legal/liquidation/approval/approve-conciliation-own.component';
import { MessageService } from './message.service';
import { ExternalRequestCaptureComponent } from './recruitment/external/external-request-capture.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardService } from './dashboard.service';
import { IncidentComponent } from './incident/incident.component';
import { IncidentService } from './incident.service';
import { VisibleOwnerIncidentDirective } from 'app/shared/directives/incident.directive';
import { SearchDirective } from 'app/shared/directives/search.directive';
import { SearchPipe } from 'app/shared/directives/search.pipe';
import { ModalIncidentComponent } from '../modales/incident/modal.incident.component';
import { IncidentDetailComponent } from './incident/detail/incident.detail.component';
import { ModalBasicDataComponet } from '../modales/employees/basic-data/modal-basic-data.component';

import { DemandComponent } from './request/legal/demands/demand.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material';
import { DemandService } from './demand.service';
import { DemandProcessComponent } from './request/legal/demands/authority-1/1-demand-process/demand-process.component';
import { ConciliatoryAppointmentComponent } from './request/legal/demands/authority-1/2-conciliatory-appointment/conciliatory-appointment.component';
import { ReceptionDemandComponent } from './request/legal/demands/authority-1/3-reception-demand/reception-demand.component';
import { LiquidationDetailComponent } from './request/legal/liquidation/liquidation-detail/liquidation-detail.component';
import { AnswerDemandComponent } from './request/legal/demands/authority-1/4-answer-demand/answer-demand.component';
import { OfferAdmissionEvidencesComponent } from './request/legal/demands/authority-1/5-offer-admission-evidences/offer-admission-evidences.component';
import { ModaloOffterAdmissionEvidencesComponet } from '../modales/demand/offter-admission-evidences/modal-offter-admission-evidences.component';
import { ReleaseEvidencesComponent } from './request/legal/demands/authority-1/6-release-evidences/release-evidences.component';
import { ModalReleaseEvidenceComponet } from '../modales/demand/offter-release-evidence/modal-release-evidence.component';
import { AllegationComponent } from './request/legal/demands/authority-1/7-allegation/allegation.component';
import { LaudoComponent } from './request/legal/demands/authority-1/8-laudo/laudo.component';
import { ConciliatoryAppointmentCourtComponent } from './request/legal/demands/authority-2/1-conciliatory-appointment/conciliatory-appointment-court.component';
import { PreliminaryAudienceComponent } from './request/legal/demands/authority-2/2-preliminary-audience/preliminary-audience.component';
import { ModalPreliminaryAudienceEvidencesComponet } from '../modales/demand/preliminary-audience-evidences/modal-preliminary-audience-evidences.component';
import { JudgmentAudienceComponent } from './request/legal/demands/authority-2/3-judgment-audience/judgment-audience.component';
import { ModalAudienceJudgmentEvidenceComponet } from '../modales/demand/audience-judgment-evidence/modal-audience-judgment-evidence.component';
import { ModalRestartDemandComponet } from '../modales/demand/restart-demand/modal-restart-demand.component';
import { ModalDemandCostComponet } from '../modales/demand/demand-cost/modal-demand-cost.component';
import { ModalUploadFilesComponet } from '../modales/opening/upload-files/modal-upload-files.component';
import { ModalDiscountDismissalComponet } from '../modales/liquidation/discount/modal-discount-dismissal.component';
import { ModalRequestMoneyComponent } from '../modales/common/request-money/modal-request-money.component';
import { MoneyService } from './money.service';
import { ModalReportLiquidationComponet } from '../modales/liquidation/reports/modal-report-liquidation.component';
// register Handsontable's modules
registerAllModules();
@NgModule({
  declarations: [
    RequestComponent,
    RequestReviewComponent,
    ProfileComponent,
    RequisitionReviewComponent,
    RequisitionDetailComponent,
    LoginComponent,
    ModalEmploymentHistoryComponet,
    ModalEmploymentHistoryCommentsComponent,
    ModalLanguageComponet,
    ModalReferenceComponet,
    ModalStudyComponet,
    ModalAppearanceComponet,
    ModalUserComponet,
    ModalUserRoleComponet,
    ModalSystemModuleComponet,
    ModalReasonRejectionComponent,
    ModalReasonCancelComponent,
    ModalEmployeesComponet,
    ModalHireEmployeeComponet,
    RemoveTildeDirective,
    UpperCaseDirective,
    LowerCaseDirective,
    OnlyNumberDirective,
    TwoDigitDecimaNumberDirective,
    FiveDigitDecimaNumberDirective,
    CurpValidateValidator,
    RequisitionTrackingComponent,
    RequisitionEditComponent,
    EmployeeComponent,
    UserComponent,
    SystemComponent,
    RoleComponent,
    ChangePasswordComponent,
    HolidayRequestComponent,
    HolidayApprovalComponent,
    InabilityRequestComponent,
    InabilityRecordsComponent,
    WorkLeaveComponent,
    WorkLeaveRecordsComponent,
    CompaniesComponent,
    ModalRiskPremiumComponet,
    ModalCompanyComponet,
    CustomersComponent,
    ModalCustomerComponet,
    ProjectsComponent,
    ModalProjectComponet,
    ModalPlanComponet,
    ProductsComponent,
    ModalProductComponet,
    ListPositionsComponent,
    PositionComponent,
    ModalCommissionComponet,
    ModalVoucherComponet,
    ListBudgetsComponent,
    BudgetComponent,
    CustomerComponent,
    WorkingDaysComponent,
    ModalWorkingDayComponet,
    ModalReasonComponent,
    NotesComponent,
    ModalNotesComponet,
    RelocationComponent,
    RelocationRecordsComponent,
    ModalBudgetApproverComponent,
    BudgetApprovalComponent,
    ModalDuplicateBudgetComponet,
    ModalBudgetVersionsComponet,
    AccountActivationComponent,
    BudgetApprovalSummaryComponent,
    ModalEmployerRegisterComponet,
    ListEmployeesComponent,
    EmployeeUpdateComponent,
    EmployeeDocumentsComponent,
    ModalMassiveUpdateComponet,
    CustomerCommissionsComponent,
    ModalCustomerCommissionComponent,
    ListCommissionsComponent,
    CommissionDetailComponent,
    RetroactivesComponent,
    ModalEmployerRegisterOfficeComponet,
    ListPayrollsComponent,
    PayrollDetailComponent,
    ModalSalaryFormatComponet,
    ModalRetentionsComponet,
    ExternalCustomerCommissionComponent,
    ExternalCustomerPayrollComponent,
    ExternalRecruitmentComponent,
    ModalRequisitionTrackingComponet,
    ModalUploadFilesComponet,
    EnterAddressComponent,
    LiquidationComponent,
    ListLiquidationsComponent,
    ExternalRequestCaptureComponent,
    ApproveConciliationOwnComponent,
    DashboardComponent,
    IncidentComponent,
    VisibleOwnerIncidentDirective,
    SearchDirective,
    ModalIncidentComponent,
    IncidentDetailComponent,
    ModalBasicDataComponet,
    DemandComponent,
    DemandProcessComponent,
    ConciliatoryAppointmentComponent,
    ReceptionDemandComponent,
    LiquidationDetailComponent,
    AnswerDemandComponent,
    OfferAdmissionEvidencesComponent,
    ModaloOffterAdmissionEvidencesComponet,
    ReleaseEvidencesComponent,
    ModalReleaseEvidenceComponet,
    AllegationComponent,
    LaudoComponent,
    ConciliatoryAppointmentCourtComponent,
    PreliminaryAudienceComponent,
    ModalPreliminaryAudienceEvidencesComponet,
    JudgmentAudienceComponent,
    ModalAudienceJudgmentEvidenceComponet,
    ModalRestartDemandComponet,
    ModalDemandCostComponet,
    ModalDiscountDismissalComponet,
    ModalRequestMoneyComponent,
    ModalReportLiquidationComponet
  ],
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    RouterModule,
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    MatRadioModule,
    MatCheckboxModule,
    MatTabsModule,
    MatStepperModule,
    SweetAlert2Module.forRoot(),
    NgxMaskModule.forRoot(),
    NgSelectModule,
    NgxDatatableModule,
    NgSlimScrollModule,
    PaginationModule.forRoot(),
    AngularMyDatePickerModule,
    HotTableModule.forRoot(),
    PopoverModule.forRoot(),
    MatIconModule,
    MatButtonModule
  ],
  entryComponents: [ModalEmploymentHistoryComponet
    , ModalEmploymentHistoryCommentsComponent
    , ModalLanguageComponet
    , ModalReferenceComponet
    , ModalStudyComponet
    , ModalAppearanceComponet
    , ModalUserComponet
    , ModalUserRoleComponet
    , ModalSystemModuleComponet
    , ModalReasonRejectionComponent
    , ModalReasonCancelComponent
    , ModalEmployeesComponet
    , ModalHireEmployeeComponet
    , ModalRiskPremiumComponet
    , ModalCompanyComponet
    , ModalCustomerComponet
    , ModalProjectComponet
    , ModalPlanComponet
    , ModalProductComponet
    , ModalCommissionComponet
    , ModalVoucherComponet
    , ModalWorkingDayComponet
    , ModalReasonComponent
    , ModalNotesComponet
    , ModalBudgetApproverComponent
    , ModalDuplicateBudgetComponet
    , ModalBudgetVersionsComponet
    , ModalEmployerRegisterComponet
    , ModalMassiveUpdateComponet
    , ModalCustomerCommissionComponent
    , ModalEmployerRegisterOfficeComponet
    , ModalSalaryFormatComponet
    , ModalRetentionsComponet
    , ModalRequisitionTrackingComponet
    , ModalIncidentComponent
    , ModalBasicDataComponet
    , ModaloOffterAdmissionEvidencesComponet
    , ModalReleaseEvidenceComponet
    , ModalPreliminaryAudienceEvidencesComponet
    , ModalAudienceJudgmentEvidenceComponet
    , ModalRestartDemandComponet
    , ModalDemandCostComponet
    , ModalUploadFilesComponet
    , ModalDiscountDismissalComponet
    , ModalRequestMoneyComponent
    , ModalReportLiquidationComponet],
  exports: [
  ],
  providers: [RecruitmentService, OpeningService, IdentityService, HolidayService, InabilityService
    , ExcelService
    , DatePipe
    , WorkLeaveService
    , OrganizationService
    , CustomerService
    , PositionService
    , BudgetService
    , WorkingDayService
    , RelocationService
    , AdministrationService
    , PayrollService
    , EmployeeService
    , CommissionService
    , RetroactiveService
    , EmailService
    , LiquidationService
    , DiscountService
    , MessageService
    , DashboardService
    , IncidentService
    , SearchPipe
    , DemandService
    , MoneyService
    , {
      provide: SLIMSCROLL_DEFAULTS,
      useValue: {
        alwaysVisible: false,
        gridOpacity: '0.2', barOpacity: '0.5',
        gridBackground: '#fff',
        gridWidth: '6',
        gridMargin: '2px 2px',
        barBackground: '#fff',
        barWidth: '20',
        barMargin: '2px 2px'
      }
    }
    , { provide: BsDatepickerConfig, useFactory: getDatepickerConfig }
    , { provide: LOCALE_ID, useValue: 'es' }],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppviewsModule {
}
